import { uploadItemImage } from 'helpers/itemPhotos';
import type { ItemPhotoRow } from 'helpers/itemPhotos';
import type { CropState } from './EditPhotoContent';
import { cropImageToBlob } from './cropImageToBlob';

/* Crops client-side, then uploads through the image-only item endpoint. Returns the
processed primary URL plus the refreshed item row so callers can update in place. */
export async function uploadCroppedPhoto(
  imageUrl: string,
  cropState: CropState,
  {
    companyId,
    enhancedAt,
    merchantId,
    itemUuid,
  }: {
    companyId: string | number;
    enhancedAt?: string | null;
    merchantId: string | number;
    itemUuid: string;
  },
): Promise<{ url: string; item: ItemPhotoRow }> {
  const croppedFile = await cropImageToBlob(imageUrl, cropState);
  let response;
  try {
    response = await uploadItemImage({
      companyId,
      merchantId,
      itemUuid,
      file: croppedFile,
      imageEnhancedAt: enhancedAt ?? undefined,
    });
  } catch (err) {
    const beMessage = (err as { response?: { data?: { detail?: string } } })?.response?.data
      ?.detail;
    throw new Error(beMessage ?? 'Upload failed. Please try again.');
  }
  const url = response?.file?.url;
  if (!url) throw new Error('Upload succeeded but returned no URL');
  if (!response.item?.uuid) throw new Error('Upload succeeded but returned no item');
  return { url, item: response.item };
}
